import LanguageDetector from "i18next-browser-languagedetector";
import { normalizeLanguageCode } from "./language-utils";

export const NormalizingDetector = {
  type: "languageDetector" as const,
  async: false,
  detect() {
    const inner = new LanguageDetector();
    inner.init({}, { order: ["navigator", "htmlTag"] });
    const detected = inner.detect();
    const codes = Array.isArray(detected) ? detected : detected ? [detected] : [];
    return codes.map(normalizeLanguageCode).filter(Boolean);
  },
  cacheUserLanguage() {},
};

export async function loadSupportedLanguages(base: string, namespace: string): Promise<string[]> {
  try {
    const res = await fetch(`${base}/${namespace}/languages.json`);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return await res.json();
  } catch (e) {
    console.warn("[i18n] Could not load languages.json, falling back to ['en']", e);
    return ["en"];
  }
}
